import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconPanelManual = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5 20.5C14.5 20.9142 14.1642 21.25 13.75 21.25H6.5C4.42893 21.25 2.75 19.5711 2.75 17.5V6.5C2.75 4.42893 4.42893 2.75 6.5 2.75H17.5C19.5711 2.75 21.25 4.42893 21.25 6.5V13.75C21.25 14.1642 20.9142 14.5 20.5 14.5C20.0858 14.5 19.75 14.1642 19.75 13.75V6.5C19.75 5.25736 18.7426 4.25 17.5 4.25H6.5C5.25736 4.25 4.25 5.25736 4.25 6.5V17.5C4.25 18.7426 5.25736 19.75 6.5 19.75H13.75C14.1642 19.75 14.5 20.0858 14.5 20.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.75 8C7.75 7.58579 8.08579 7.25 8.5 7.25H15.5C15.9142 7.25 16.25 7.58579 16.25 8C16.25 8.41421 15.9142 8.75 15.5 8.75H8.5C8.08579 8.75 7.75 8.41421 7.75 8Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.7249 17.6642L16.7803 15.7197C16.4874 15.4268 16.0126 15.4268 15.7197 15.7197C15.4268 16.0126 15.4268 16.4874 15.7197 16.7803L17.6642 18.7249L15.7197 20.6694C15.4268 20.9623 15.4268 21.4372 15.7197 21.7301C16.0126 22.023 16.4874 22.023 16.7803 21.7301L18.7249 19.7855L20.6694 21.7301C20.9623 22.023 21.4372 22.023 21.7301 21.7301C22.023 21.4372 22.023 20.9623 21.7301 20.6694L19.7855 18.7249L21.7301 16.7803C22.023 16.4874 22.023 16.0126 21.7301 15.7197C21.4372 15.4268 20.9623 15.4268 20.6694 15.7197L18.7249 17.6642Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconPanelManual as ReactComponent };
